import { PostGraduateYear } from "./PostGraduateYear";

export class EligibilityRequirements {    
    certificationNames: Array<string>;
    certificationIds: Array<number>;
    certificationTrainingRequirements: Array<CertificationTrainingRequirement>;
    requiredNumberOfPGYs: number;
    residentAcceptedPGYs: Array<PostGraduateYear>;
    isTrainingEligibleForFinalAttestation: boolean;
}

export class CertificationTrainingRequirement {
    title: string;
    isComplete: boolean;
    isRequired: boolean;
    requirementType: KnownTrainingRequirementType;
    clinicalSkillEvaluationType: number;
    subRequirementResults: Array<CertificationTrainingRequirement>;
    clinicalSkillTypeId: number;
}

export enum KnownTrainingRequirementType {
    ClinicalSkillEvaluation = 1,
    PostGraduateYear = 2,
    RequiredForCseFinalAttestation = 3,
    RequiredForPgyFinalAttestation = 4
}

export enum KnownCertificationType {
    Psychiatry = 19, 
    CAP = 12
}